// Category IDs mapped to display names
export const CATEGORY_NAMES: Record<number, string> = {
  1: 'Nature',
  2: 'Urban',
  4: 'Historical',
  7: 'Educational',
  9: 'Other',
}

// Category colors for consistent chart styling
export const CATEGORY_COLORS: Record<number, string> = {
  1: '#4CAF50', // Nature - Green
  2: '#2196F3', // Urban - Blue
  4: '#9C27B0', // Historical - Purple
  7: '#FF9800', // Educational - Orange
  9: '#607D8B', // Other - Gray
}

// Chart theme colors - work well in both light and dark modes
export const CHART_COLORS = {
  activeUsers: '#8B1538', // Primary brand color
  newUsers: '#4CAF50', // Success green
  soloCompletions: '#2196F3', // Blue
  groupCompletions: '#FF9800', // Orange
  grid: '#e0e0e0',
  gridDark: '#424242',
  axis: '#666666',
  axisDark: '#9e9e9e',
}

// Get all category colors as an array for stacked charts
export const getCategoryColorArray = (): string[] =>
  Object.values(CATEGORY_COLORS)

// Get category name from ID with fallback
export const getCategoryName = (categoryId: number): string =>
  CATEGORY_NAMES[categoryId] || `Category ${categoryId}`
